import { createAPIService } from './api.service';

export const MAIN_ENDPOINT = '/user/api/v2/admin/policies';

const service = createAPIService(MAIN_ENDPOINT);

// endpoints
service.getPolicy = async policyId => (await service.get(`/${policyId}`)).data;

service.getPolicies = async params =>
  (await service.get('', { params: params })).data;

service.createPolicy = async policy => (await service.post('', policy)).data;

service.updatePolicy = async (policyId, policy) =>
  (await service.patch(`/${policyId}`, policy)).data;

service.deletePolicy = async policyId =>
  (await service.delete(`/${policyId}`)).data;

service.operatePolicy = async (id, lock) =>
  (await service.post(`/${id}/operations?lock=${lock}`)).data;

// Policy permissions
service.getPolicyPermissions = async (id, params) =>
  (await service.get(`/${id}/permissions`, { params: params })).data;

service.addPolicyPermissions = async (id, permissions) =>
  (await service.post(`/${id}/permissions`, permissions)).data;

service.deletePolicyPermissions = async (id, permissions) =>
  (await service.delete(`/${id}/permissions?ids=${permissions.join()}`)).data;

export default service;
